import { APITester } from "./APITester";
import "./index.css";

import logo from "./logo.svg";
import reactLogo from "./react.svg";

export function App() {
  return (
    <div className="app">
      <h1>Michael LaDouceur</h1>
    </div>
  );
}

export default App;
